import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';
import { handleFFTV2DataByTimestampConversion, handleFFTV2DataConversion } from './assetDetailsUoMHelper';


class AssetDetails {

    getAssetPicturesV2(assetID) {
        const endpoint = formatEndpoint(endpoints.assetDetails.pictures.getAssetNameplatePicturesV2, { assetID });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    generateUploadURL(assetID, fileName) {
        const endpoint = formatEndpoint(endpoints.assetDetails.pictures.generateUploadURL, { assetID });
        return RestManagerWithoutBaseUrl.post(endpoint, { fileName });
    }

    getSmartConditionSummary(assetId) {
        const endpoint = formatEndpoint(endpoints.assetDetails.getSmartConditionSummary, { assetId });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    uploadAssetPicture(assetID, pictureId, fileName, uploadUrl, pictureType) {
        const endpoint = formatEndpoint(endpoints.assetDetails.pictures.uploadAssetPicture, { assetID });
        return RestManagerWithoutBaseUrl.put(endpoint, { pictureId, fileName, uploadUrl, pictureType });
    }

    uploadToSignedUrl(url, data, headers) {
        return fetch(url, {
            method: 'PUT',
            headers: headers,
            body: data
        });
    }


    //  SENSOR PROPERTIES START
    getSensorProperties(id) {
        const endpoint = formatEndpoint(endpoints.sensor.getSensorProperties, { id });
        return RestManagerWithoutBaseUrl.get(endpoint);

    }

    getSensorGatewayInfo(sensorId) {
        const endpoint = formatEndpoint(endpoints.sensor.getSensorGatewayInfo, { sensorId });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    getSensorTimeseriesConfig(sensorId) {
        const endpoint = formatEndpoint(endpoints.sensor.getSensorTimeseriesConfig, { sensorId });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    getSensorTimeSeries(sensors) {
        const endpoint = endpoints.sensor.getSensorTimeSeries;
        return RestManagerWithoutBaseUrl.post(endpoint, { sensors });
    }

    getRssiValue(sensorId) {
        const endpoint = formatEndpoint(endpoints.sensor.getRssiValue, { sensorId });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    getSensorBatteryLevel(sensorId) {
        const endpoint = { ...endpoints.sensor.getSensorBatteryLevel, url: `${endpoints.sensor.getSensorBatteryLevel.url}?sensorId=${sensorId}` };
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    getSensorFeatures(firmwareID, sensorIdentifier, sensorTypeID) {
        const endpoint = formatEndpoint(endpoints.assetDetails.sensorDetails.getSensorFeatures, { firmwareID, sensorIdentifier, sensorTypeID });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    // Microservice endpoint
    getFFTV2Data(assetID) {
        const endpoint = formatEndpoint(endpoints.assetDetails.fftV2Data.getFFTV2Data, { assetID });
        return RestManagerWithoutBaseUrl.get(endpoint).then(response => handleFFTV2DataConversion(response));
    }

    getFFTTimestampList(assetID, startTime, endTime) {
        const endpoint = formatEndpoint(endpoints.assetDetails.fftV2Data.getFFTTimestampList, { assetID, startTime, endTime });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    getFFTDataByTimestamp(params) {
        const endpoint = formatEndpoint(endpoints.assetDetails.fftV2Data.getFFTDataByTimestamp);
        return RestManagerWithoutBaseUrl.post(endpoint, params).then(response => handleFFTV2DataByTimestampConversion(response));
    }


    downloadRawDataV2(params) {
        const endpoint = formatEndpoint(endpoints.assetDetails.fftV2Data.downloadRawDataV2);
        return RestManagerWithoutBaseUrl.post(endpoint, params);
    }

    deleteAssetImage(assetID, pictureId) {
        const endpoint = formatEndpoint(endpoints.assetDetails.pictures.deleteAssetPicture, { assetID, pictureId });
        return RestManagerWithoutBaseUrl.delete(endpoint);
    }

    getAssetOverview(assetID) {
        const endpoint = formatEndpoint(endpoints.assetDetails.getAssetOverview, { assetID });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    getPhysicalConnectionsByAsset(assetId) {
        const endpoint = formatEndpoint(endpoints.assetDetails.getPhysicalConnectionsByAsset);
        return RestManagerWithoutBaseUrl.post(endpoint, { assetId });
    }
}

export default new AssetDetails();
